module.exports = __webpack_public_path__ + "img/03_C_T.0529a285.png";